<p-selectButton [options]="tags" [(ngModel)]="selectedTags" optionLabel="label" (onChange)="tagChanged($event)"
	(onOptionClick)="optionClicked($event)" [multiple]="true">
	<ng-template let-item>
		<div class="button-wrapppper tag-{{item.value?.name}}">
			<span class="ui-button-text ui-clickable">{{item.label}}</span>
			<div *ngIf="item.value?.name === 'Amount' && showInput">
				<p-inputNumber #tagAmount [(ngModel)]="checkItem.changeOrderAmount" mode="currency" currency="USD"
					locale="en-US" [minFractionDigits]="2" (click)="onInputClick($event)">
				</p-inputNumber>

				<!-- <p-inputMask mask="$0" [(ngModel)]="checkItem.changeOrderAmount" placeholder="$0"></p-inputMask> -->
			</div>
		</div>
	</ng-template>
</p-selectButton>
